(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-back-link"]) return;
  try {
    
  if (!customElements.get('back-to-collection')) {
    class BackToCollection extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('[data-back-link]');
        const label = this.querySelector('[data-back-label]');
        const optionsElement = this.querySelector('[data-collection-options]');

        if (!link || !label || !optionsElement) return;

        let collections = [];

        try {
          collections = JSON.parse(optionsElement.textContent);
        } catch (error) {
          return;
        }

        if (!Array.isArray(collections) || collections.length === 0) return;

        const candidates = [];

        try {
          const currentUrl = new URL(window.location.href);
          const referrerUrl = document.referrer ? new URL(document.referrer) : null;
          candidates.push(currentUrl);

          if (referrerUrl && referrerUrl.origin === currentUrl.origin) {
            candidates.push(referrerUrl);
          }
        } catch (error) {
          return;
        }

        const matchingCollection = collections.find((item) => {
          return candidates.some((candidate) => {
            return candidate.pathname === item.url
              || candidate.pathname.startsWith(`${item.url}/`);
          });
        });

        if (!matchingCollection) return;

        link.href = matchingCollection.url;
        link.setAttribute('aria-label', matchingCollection.title);
        label.textContent = matchingCollection.title;
      }
    }

    customElements.define('back-to-collection', BackToCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veluxa-birthday"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
 const card = event.target.closest('[data-vb-card]');
 if (!card) return;
 const expanded = card.getAttribute('aria-expanded') !== 'true';
 card.setAttribute('aria-expanded', String(expanded));
 card.querySelector('.vb-card__front').setAttribute('aria-hidden', String(expanded));
 card.querySelector('.vb-card__back').setAttribute('aria-hidden', String(!expanded));
 const cards = card.closest('.vb-cards');
 if (cards) cards.dataset.vbTouched = 'true';
});

// Co kilka sekund odwraca losową kartę, żeby pokazać, że karty są klikalne.
// Przestaje po pierwszym kliknięciu klienta w dowolną kartę.
(() => {
 const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
 const mounted = new WeakSet();
 function mount(root) {
  if (mounted.has(root)) return;
  const cards = Array.from(root.querySelectorAll('[data-vb-card]'));
  if (!cards.length) return;
  mounted.add(root);
  let visible = false;
  let last = -1;
  let timer = 0;
  function schedule(delay) {
   clearTimeout(timer);
   timer = setTimeout(peek, delay);
  }
  function peek() {
   if (root.dataset.vbTouched === 'true' || !root.isConnected) return;
   if (!visible || document.hidden || reducedMotion.matches) return schedule(2000);
   const closed = cards.map((c, i) => i).filter(i => i !== last && cards[i].getAttribute('aria-expanded') !== 'true' && !cards[i].matches(':hover'));
   if (!closed.length) return schedule(2000);
   last = closed[Math.floor(Math.random() * closed.length)];
   const card = cards[last];
   card.classList.add('vb-card--peek');
   setTimeout(() => card.classList.remove('vb-card--peek'), 2200);
   schedule(5200);
  }
  new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold: .5}).observe(root);
  schedule(2500);
 }
 const mountAll = () => document.querySelectorAll('.vb-cards').forEach(mount);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, {once:true});
 else mountAll();
 document.addEventListener('shopify:section:load', mountAll);
})();

(() => {
 const instances = new Map();
 function mount(root) {
  if (instances.has(root)) return;
  const track = root.querySelector('[data-vb-reviews-track]');
  const slides = Array.from(root.querySelectorAll('[data-vb-review]'));
  const dots = Array.from(root.querySelectorAll('[data-vb-reviews-dot]'));
  const prev = root.querySelector('[data-vb-reviews-prev]');
  const next = root.querySelector('[data-vb-reviews-next]');
  if (!track || slides.length < 2) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let current = 0;
  let timer = 0;
  let hovered = false;
  let focused = false;
  let visible = false;
  function setCurrent(index) {
   current = index;
   dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
  }
  function go(index) {
   const target = (index + slides.length) % slides.length;
   track.scrollTo({left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
   setCurrent(target);
  }
  function stop() { clearInterval(timer); timer = 0; }
  function start() {
   stop();
   if (root.dataset.autoplay !== 'true' || reducedMotion.matches || hovered || focused || !visible || document.hidden) return;
   timer = setInterval(() => go(current + 1), 7000);
  }
  let scrollFrame = 0;
  const onScroll = () => {
   if (scrollFrame) return;
   scrollFrame = requestAnimationFrame(() => {
    scrollFrame = 0;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    if (index !== current && slides[index]) setCurrent(index);
   });
  };
  const onDot = event => { go(dots.indexOf(event.currentTarget)); start(); };
  const onPrev = () => { go(current - 1); start(); };
  const onNext = () => { go(current + 1); start(); };
  const onEnter = () => { hovered = true; stop(); };
  const onLeave = () => { hovered = false; start(); };
  const onFocusIn = () => { focused = true; stop(); };
  const onFocusOut = event => { if (!root.contains(event.relatedTarget)) { focused = false; start(); } };
  const onTouch = () => start();
  const onBlockSelect = event => {
   const index = slides.indexOf(event.target);
   if (index > -1) { go(index); stop(); }
  };
  const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; start(); });
  track.addEventListener('scroll', onScroll, {passive:true});
  track.addEventListener('touchend', onTouch, {passive:true});
  dots.forEach(dot => dot.addEventListener('click', onDot));
  if (prev) prev.addEventListener('click', onPrev);
  if (next) next.addEventListener('click', onNext);
  root.addEventListener('mouseenter', onEnter);
  root.addEventListener('mouseleave', onLeave);
  root.addEventListener('focusin', onFocusIn);
  root.addEventListener('focusout', onFocusOut);
  document.addEventListener('visibilitychange', start);
  reducedMotion.addEventListener('change', start);
  document.addEventListener('shopify:block:select', onBlockSelect);
  observer.observe(root);
  instances.set(root, () => {
   stop();
   cancelAnimationFrame(scrollFrame);
   observer.disconnect();
   track.removeEventListener('scroll', onScroll);
   track.removeEventListener('touchend', onTouch);
   dots.forEach(dot => dot.removeEventListener('click', onDot));
   if (prev) prev.removeEventListener('click', onPrev);
   if (next) next.removeEventListener('click', onNext);
   root.removeEventListener('mouseenter', onEnter);
   root.removeEventListener('mouseleave', onLeave);
   root.removeEventListener('focusin', onFocusIn);
   root.removeEventListener('focusout', onFocusOut);
   document.removeEventListener('visibilitychange', start);
   reducedMotion.removeEventListener('change', start);
   document.removeEventListener('shopify:block:select', onBlockSelect);
   instances.delete(root);
  });
 }
 const mountAll = () => document.querySelectorAll('[data-vb-reviews]').forEach(mount);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, {once:true});
 else mountAll();
 document.addEventListener('shopify:section:load', mountAll);
 document.addEventListener('shopify:section:unload', event => {
  instances.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
 });
})();

(() => {
 const instances = new Map();
 function mount(phone) {
  if (instances.has(phone)) return;
  const feed = phone.querySelector('.vb-phone__feed');
  const viewport = phone.querySelector('.vb-phone__viewport');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let current = null;
  function update() {
   frame = 0;
   const bounds = phone.getBoundingClientRect();
   const start = window.innerHeight * 0.55;
   const end = -bounds.height * 0.6;
   const progress = Math.max(0, Math.min(1, (start - bounds.top) / (start - end)));
   const distance = Math.max(0, feed.getBoundingClientRect().height - viewport.clientHeight);
   const statusHeight = Math.min(distance, phone.querySelector('.vb-phone__status').clientHeight);
   const share = Math.max(0.1, Math.min(1, Number(phone.dataset.scrollShare || 60) / 100));
   const still = reducedMotion.matches || phone.dataset.scrollEnabled !== 'true';
   const target = still ? statusHeight : statusHeight + progress * (distance - statusHeight) * share;
   current = current === null || still ? target : current + (target - current) * 0.12;
   feed.style.setProperty('--vb-feed-y', -current + 'px');
   if (Math.abs(target - current) > 0.5) frame = requestAnimationFrame(update);
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  const observer = new ResizeObserver(schedule);
  observer.observe(viewport);
  observer.observe(feed);
  feed.addEventListener('load', schedule);
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  reducedMotion.addEventListener('change', schedule);
  schedule();
  instances.set(phone, () => {
   cancelAnimationFrame(frame);
   observer.disconnect();
   feed.removeEventListener('load', schedule);
   window.removeEventListener('scroll', schedule);
   window.removeEventListener('resize', schedule);
   reducedMotion.removeEventListener('change', schedule);
   instances.delete(phone);
  });
 }
 const mountAll = () => document.querySelectorAll('[data-vb-phone]').forEach(mount);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, {once:true});
 else mountAll();
 document.addEventListener('shopify:section:load', mountAll);
 document.addEventListener('shopify:section:unload', event => {
  instances.forEach((destroy, phone) => { if (event.target.contains(phone)) destroy(); });
 });
})();

(() => {
 const instances = new Map();
 function mount(root) {
  const canvas = root.querySelector('[data-vb-confetti]');
  if (!canvas || instances.has(root)) return;
  const context = canvas.getContext('2d');
  if (!context) return;
  const button = root.querySelector('[data-vb-motion]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reducedMotion.matches;
  let visible = false;
  let width = 0;
  let height = 0;
  let frame = 0;
  let previous = 0;
  let elapsed = 0;
  let particles = [];
  function updateButton() {
   button.hidden = false;
   button.textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
   button.setAttribute('aria-pressed', String(paused));
  }
  function paint(time) {
   frame = 0;
   const bounds = root.getBoundingClientRect();
   const offset = Math.max(0, -bounds.top);
   canvas.style.transform = 'translateY(' + offset + 'px)';
   context.clearRect(0, 0, width, height);
   if (!paused && previous) elapsed += Math.min((time - previous) / 1000, 0.05);
   previous = time;
   particles.forEach(p => {
    const cycle = height + 80;
    const x = p.x * width + Math.sin(elapsed * p.sway + p.phase) * 26;
    const y = ((p.y * cycle + elapsed * p.speed - offset * 0.2) % cycle + cycle) % cycle - 40;
    context.save();
    context.translate(x, y);
    context.rotate(p.phase + elapsed * p.spin);
    context.scale(Math.cos(p.phase + elapsed * p.sway) * 0.7 + 0.3, 1);
    context.globalAlpha = p.opacity;
    const gold = context.createLinearGradient(-p.w / 2, 0, p.w / 2, p.h);
    gold.addColorStop(0, '#926526');
    gold.addColorStop(0.35, '#d3aa56');
    gold.addColorStop(0.55, '#f9e4ad');
    gold.addColorStop(1, '#b18735');
    context.fillStyle = gold;
    context.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
    context.restore();
   });
   if (visible && !paused && !document.hidden) frame = requestAnimationFrame(paint);
  }
  function refresh() {
   if (frame) cancelAnimationFrame(frame);
   previous = 0;
   frame = requestAnimationFrame(paint);
  }
  function resize() {
   width = root.clientWidth;
   height = window.innerHeight;
   const ratio = Math.min(window.devicePixelRatio || 1, 2);
   canvas.width = Math.round(width * ratio);
   canvas.height = Math.round(height * ratio);
   canvas.style.height = height + 'px';
   context.setTransform(ratio, 0, 0, ratio, 0, 0);
   particles = Array.from({length:width < 600 ? 32 : 72}, (_, i) => ({
    x:((i * 47 + 13) % 101) / 101, y:((i * 31 + 9) % 103) / 103,
    w:4 + i % 6, h:9 + i % 13, speed:30 + i % 37,
    phase:i * 2.4, spin:(i % 2 ? 1 : -1) * (0.3 + i % 5 / 10),
    sway:0.7 + i % 4 / 10, opacity:0.35 + i % 5 * 0.08
   }));
   refresh();
  }
  const observer = new IntersectionObserver(entries => {
   visible = entries[0].isIntersecting;
   refresh();
  });
  const resizeObserver = new ResizeObserver(resize);
  const onScroll = () => { if (!frame && visible) refresh(); };
  const onPreference = () => { paused = reducedMotion.matches; updateButton(); refresh(); };
  const onToggle = () => { paused = !paused; updateButton(); refresh(); };
  button.addEventListener('click', onToggle);
  reducedMotion.addEventListener('change', onPreference);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', resize, {passive:true});
  observer.observe(root);
  resizeObserver.observe(root);
  updateButton();
  resize();
  instances.set(root, () => {
   cancelAnimationFrame(frame);
   observer.disconnect();
   resizeObserver.disconnect();
   button.removeEventListener('click', onToggle);
   reducedMotion.removeEventListener('change', onPreference);
   document.removeEventListener('visibilitychange', refresh);
   window.removeEventListener('scroll', onScroll);
   window.removeEventListener('resize', resize);
   instances.delete(root);
  });
 }
 const mountAll = () => document.querySelectorAll('[data-vb-root]').forEach(mount);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, {once:true});
 else mountAll();
 document.addEventListener('shopify:section:load', mountAll);
 document.addEventListener('shopify:section:unload', event => {
  instances.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
 });
})();


  } catch(e) { console.error(e); }
})();
})();
